import { QuestionStatus } from '@exam-management/graphql';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { Box, Flex, FormRadioSelection, InfoOutlinedIcon, Text, Tooltip } from '@shared/components';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { LotOfQuestionField } from '../../components';
import { LocationFormFields } from '../location-form-fields';

const LOQ_OPTIONS = [
  { label: 'No', value: 'false' },
  { label: 'Yes', value: 'true' },
];

interface LocationFormSectionProps {
  questionStatus?: QuestionStatus;
}

export default function LocationFormSection(props: Readonly<LocationFormSectionProps>) {
  const { questionStatus = QuestionStatus.Draft } = props;
  // NOTE: remove this condition if we can create LOQ question at question creation task someday
  const isPreDraft = questionStatus === QuestionStatus.PreDraft;

  const { qBankStructureLevels, qBankStructureLevelItems } = useQBankStructure();
  const formContext = useFormContext();
  const qBankStructureLevelWithoutFirstLevel = useMemo(
    () => qBankStructureLevels.filter((qBankStructureLevel) => qBankStructureLevel.level !== 1),
    [qBankStructureLevels],
  );

  const LOQSelected = formContext.watch('location.LOQ.selected');
  const subTopicLevelItemId = formContext.watch('location.SUB_TOPIC')?.value;

  useEffect(() => {
    if (!subTopicLevelItemId) {
      formContext.setValue('location.LOQ.selected', 'false');
    }
  }, [subTopicLevelItemId]);

  useEffect(() => {
    if (LOQSelected === 'false') {
      formContext.setValue('location.LOQ.value', undefined);
    }
  }, [LOQSelected]);

  return (
    <>
      <LocationFormFields
        prefix='location'
        qbsLevels={qBankStructureLevelWithoutFirstLevel}
        qbsLevelItems={qBankStructureLevelItems}
      />
      {/*
        NOTE: we hide LOQ section because we can't create LOQ question at question creation task right now
        If requirement change someday, feel free to remove this ternary operator
      */}
      {!isPreDraft ? (
        <>
          <Box>
            <Flex sx={(theme) => ({ gap: theme.spacing(1) })}>
              <Text variant='body2Semibold'>เป็น LOQ ไหม?</Text>
              <Tooltip title='ชุดของข้อสอบที่มีความคล้ายคลึงกันมาก'>
                <InfoOutlinedIcon
                  sx={{ fontSize: '20px', color: (theme) => theme.palette.text.secondary }}
                />
              </Tooltip>
            </Flex>
            <FormRadioSelection
              name='location.LOQ.selected'
              disabled={!subTopicLevelItemId}
              options={LOQ_OPTIONS}
              row
              onChange={() => formContext.clearErrors('location.LOQ.value')}
              defaultValue='false'
            />
          </Box>
          <LotOfQuestionField
            subTopicLevelItemId={subTopicLevelItemId}
            disabled={LOQSelected !== 'true'}
            name='location.LOQ.value'
          />
        </>
      ) : null}
    </>
  );
}
